import React from 'react'

import { COLOR_INDICATORS, IS_ARTIST } from '@disco/constants/FeatureTypes'
import type { featureData } from '@disco/state-management/selectors/business'
import {
  useFeatureData,
  useFeatureEnabled,
} from '@disco/state-management/selectors/business'

import Alert from 'components/ui/alert'
import ContactUsLink from 'components/ui/contact-us-link'
import InlineLink from 'components/ui/inline-link'

const INTERCOM_MESSAGE: string =
  'I’d like to Upgrade to Pro to access color indicators'

/**
 * Alert component that informs users about color indicators feature availability
 * Shows different messages based on subscription status and feature enablement
 */
const ColorIndicatorsAlert = (): React.ReactNode => {
  const { isTrial, isFeatureEnabled: colorIndicatorsEnabled }: featureData =
    useFeatureData(COLOR_INDICATORS)
  const isArtist = useFeatureEnabled(IS_ARTIST)
  return colorIndicatorsEnabled && !isArtist ? (
    <Alert dismissible id="color_indicators_enabled" status="change">
      You can now add color indicators for your most important tags.{' '}
      <InlineLink
        to="https://support.disco.ac/home/using-color-indicators-for-playlist-and-track-tags"
        rel="noopener noreferrer"
        target="_blank"
      >
        Find out more.
      </InlineLink>
    </Alert>
  ) : (
    <Alert dismissible id="color_indicators_disabled" status="warning">
      {isTrial ? (
        <InlineLink to="/settings/billing">Subscribe to Pro</InlineLink>
      ) : (
        <ContactUsLink intercomMsg={INTERCOM_MESSAGE}>
          Upgrade to Pro
        </ContactUsLink>
      )}{' '}
      <span>to add color indicators for your most important tags.</span>
    </Alert>
  )
}

export default ColorIndicatorsAlert
